import { Drawer as DrawerAntd } from 'antd';
import styled from 'styled-components';

const Drawer = styled(DrawerAntd)`
  .ant-drawer-content-wrapper {
    overflow: auto;
    max-width: 100vw;
  }

  .ant-drawer-content {
    width: ${(props) => {
      return props.width ? `${props.width}px` : '100%';
    }};
  }

  .ant-drawer-title {
    font-size: 20px;
    font-weight: 600;
    line-height: 142%;
  }

  .ant-drawer-close .anticon {
    font-size: 16px;
    color: #000000a6;
  }

  .ant-drawer-body {
    overflow: unset;
  }
  .ant-drawer-footer {
    padding: 24px;
    display: inline-flex;
    > button:last-child {
      margin-left: auto;
    }
  }
`;

export default Drawer;
